import { GoogleTagManagerService } from './../../../services/analytics/google-tag-manager.service';
import { Component, HostListener, Inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { InfoWindowContentComponent } from 'app/components/modal/dialog-map-nearby/info-window-content/info-window-content.component';
import { ProductNearByDTO } from 'app/model/products/product-nearby-dto.model';
import { ProductReviewModel } from 'app/model/products/product-review.model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { ProductService } from 'app/services/products/product.service';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import $ from 'jquery';
import platform from 'platform';
import { Subscription } from 'rxjs/Subscription';
import { DefaultValue, Page } from '../../../model/constant';
import { HotelListRequest } from '../../../model/products/hotel/hotel.model';
import { SearchFormModel } from '../../../model/search-form-model';
import { UserService } from '../../../services/user/user.service';
import { ActInfoMarker } from '../../../utilities/act-map/directives/info-marker';
import { CurrencyService } from 'app/services/currency/currency.service';
import { Currency } from 'app/model/currency.model';

@Component({
  selector: 'act-dialog-map-nearby',
  templateUrl: './dialog-map-nearby.component.html',
  styleUrls: ['./dialog-map-nearby.component.scss']
})
export class DialogMapNearbyComponent implements OnInit, OnDestroy {
  reviewRating: ProductReviewModel;
  public currency: Currency;

  private isMobile: boolean = false; // tslint:disable-line
  private resetCenter: boolean = false; // tslint:disable-line
  private infoWindowKey: any;
  private $mapElement: any;
  private $infoWindowElement: any;
  private productNearByList: any;
  private isAllPopOverComplete = false;
  private countPopOver = 0;
  private countMarker = 0;
  private product: ProductNearByDTO;
  private gaSent = false;
  private now = new Date().getTime() / 1000;
  private zoom = 11;
  private radius = DefaultValue.DISTANCE;

  private getProductNearBySubScription: Subscription;
  private currencySubscription: Subscription;

  @ViewChild(InfoWindowContentComponent)
  private infoWindowContentComponent: InfoWindowContentComponent;

  @ViewChildren(ActInfoMarker)
  private infoMarker: QueryList<ActInfoMarker>;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: {
      product: any;
      searchData: SearchFormModel;
      page: Page;
      hotelListRequest: HotelListRequest;
    },
    public dialogRef: MdDialogRef<DialogMapNearbyComponent>,
    private productService: ProductService,
    private utilitiesService: UtilitiesService,
    private appConfigService: AppConfigService,
    private userService: UserService,
    private googleTagManagerService: GoogleTagManagerService,
    private currencyService: CurrencyService,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize() {
    document.documentElement.style.setProperty('--dialog-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    this.onResize();
    if (this.data && this.data.product) {
      if (this.data.product.reviewRatingScore) {
        this.reviewRating = new ProductReviewModel(
          '' + this.data.product.reviewRatingScore,
          this.productService.calculateReviewRatingTitle(this.data.product.reviewRatingScore)
        );
      }
      this.product = this.data.product;
    }
    this.product && this.getProductNearBy(this.product);
    this.utilitiesService.isMobile() && (this.isMobile = true);
    this.googleTagManagerService.emitEvent(
      'Nearby Map Search',
      'Loading',
      this.data && this.data.product ? this.data.product.productTitle || '' : '',
      0
    );

    this.subscribeCurrency();
  }

  ngOnDestroy() {
    this.getProductNearBySubScription && this.getProductNearBySubScription.unsubscribe();
    this.currencySubscription && this.currencySubscription.unsubscribe();
    this.utilitiesService.unlockBody();
    this.utilitiesService.unlockBodyBackdrop();
  }

  setInfoWindowData(image: String, title: String, rating: Number, keyMarker: String, review: ProductReviewModel, displayNavigate = false) {
    this.infoWindowKey = {
      key: keyMarker
    };
    this.infoWindowContentComponent.setData(image, title, rating, review, true, displayNavigate);
  }

  getProductNearBy(data: ProductNearByDTO) {
    this.getProductNearBySubScription && this.getProductNearBySubScription.unsubscribe();
    this.data.hotelListRequest.filterRequest.distance = this.radius;
    this.getProductNearBySubScription = this.productService.getProductListWithPOI(this.data.hotelListRequest).subscribe(res => {
      this.productNearByList = res.items;
      this.productNearByList.forEach(e => {
        e.reviewRating = new ProductReviewModel(e.reviewRatingScore, this.productService.calculateReviewRatingTitle(e.reviewRatingScore));
      });
    });
  }

  calculateZoom() {
    let tmpDistanceLat = 0;
    let tmpDistanceLon = 0;
    const centerLon = Number(this.product.longitude);
    const centerLat = Number(this.product.latitude);
    let distanceLat = Math.abs(Number(this.product.latitude) - centerLat);
    let distanceLon = Math.abs(Number(this.product.longitude) - centerLon);
    this.productNearByList.forEach(element => {
      if (this.product.productId !== element.productId) {
        tmpDistanceLat = Math.abs(element.latitude.valueOf() - centerLat);
        tmpDistanceLon = Math.abs(element.longitude.valueOf() - centerLon);
        distanceLat = tmpDistanceLat > distanceLat ? tmpDistanceLat : distanceLat;
        distanceLon = tmpDistanceLon > distanceLon ? tmpDistanceLon : distanceLon;
      }
    });

    const mapElement = <HTMLElement>document.querySelector('.dialog-map');
    const widthPixel = this.isMobile ? mapElement.offsetWidth / 3.5 : 256;
    const heightPixel = this.isMobile ? mapElement.offsetHeight / 4.2 : 148;
    const GLOBE_WIDTH = 256;
    const zoomLat = Math.round(Math.log(heightPixel * 360 / distanceLat / GLOBE_WIDTH) / Math.LN2);
    const zoomLon = Math.round(Math.log(widthPixel * 360 / distanceLon / GLOBE_WIDTH) / Math.LN2);
    this.zoom = zoomLat < zoomLon ? zoomLat : zoomLon;
  }

  onMarkerClicked(data) {
    const key = data && data.key ? data.key : undefined;
    this.isMobile && key && this.setActiveMarker(key);
    switch (key) {
      case undefined:
        break;
      case `center`:
        this.setInfoWindowData(
          this.data.product.imageUrl,
          this.data.product.productTitle,
          this.data.product.hotelStar,
          key,
          this.reviewRating,
          true
        );
        break;
      default:
        const product = this.productNearByList[key];
        this.setInfoWindowData(
          product.imageUrl,
          product.productTitle,
          product.hotelStar,
          data.key,
          new ProductReviewModel('' + product.reviewRatingScore, this.productService.calculateReviewRatingTitle(product.reviewRatingScore))
        );
        break;
    }
  }

  onPopOverClicked(data) {
    if (data && data.key === 'center') {
      this.data.page !== Page.LEVEL_D && this.goToProductDetail(
        this.data.product.productId,
        this.data.product.slug,
        this.data.product.productTitle,
      );
    } else {
      const product = this.productNearByList[data.key];
      this.goToProductDetail(
        product.productId,
        product.slug,
        product.productTitle
      );
    }
  }

  onRenderMarkerComplete(event) {
    ++this.countMarker;
    event === 'center' && this.infoWindowContentComponent && this.isMobile && this.setInfoWindowData(
      this.data.product.imageUrl,
      this.data.product.productTitle,
      this.data.product.hotelStar,
      'center',
      this.reviewRating,
      true
    );
    const allMarker = this.productNearByList && this.productNearByList.length > 0
      ? this.productNearByList.length + 1 : 1;
    this.isMobile && allMarker === this.countMarker && (this.resetCenter = true);
    this.resetCenter && this.iPhoneUpdateSizing();
    this.resetCenter && this.setActiveMarker('center');
  }

  onRenderPopOverComplete(event) {
    ++this.countPopOver;
    const allPopOver = this.productNearByList && this.productNearByList.length > 0
      ? this.productNearByList.length + 1 : 1;
    allPopOver === this.countPopOver && allPopOver === this.countMarker
      && (this.isAllPopOverComplete = this.resetCenter = true);
    this.resetCenter && this.iPhoneUpdateSizing();
  }

  sendGAMapLoaded() {
    if (!this.gaSent) {
      this.gaSent = true;
      this.calculateZoom();
      let maxDistance = Math.max.apply(Math, this.productNearByList.map(o => { return o.distance; }));
      let tempRadius = Math.round((maxDistance * 1.01) / Math.LN2);
      this.radius = tempRadius > this.data.product.radius ? this.data.product.radius : tempRadius;
      this.googleTagManagerService.emitEvent(
        'Nearby Map Search',
        'Loaded',
        this.data && this.data.product ? this.data.product.productTitle || '' : '',
        Math.round(new Date().getTime() / 1000 - this.now)
      )
    }
  }

  goToProductDetail(id, slug, title) {
    this.removeLink();
    const url = this.productService.getProductDetailsUrl({
      id,
      slug,
      suggestCat: 'product',
      title,
      purpose: this.data.searchData.purpose,
      checkInDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkInDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
      checkOutDate: this.utilitiesService.convertDateFormat(this.data.searchData.checkOutDate, 'YYYY-MM-DD', 'DD-MM-YYYY', 'en'),
      guests: this.data.searchData.guests,
      breakfast: false,
      overBudget: false,
      isReverseFormatDate: false
    });
    this.setLink(url);
  }

  setLink(url) {
    const link = document.getElementById('link-to-product-detail') as HTMLElement;
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.click();
  }

  removeLink() {
    const link = document.getElementById('link-to-product-detail') as HTMLElement;
    link.removeAttribute('target');
    link.removeAttribute('href');
  }

  resetIphoneHandler() {
    this.$mapElement && this.$mapElement.removeClass('iphone');
  }

  iPhoneUpdateSizing() {
    this.$mapElement = $('.act-map-container-inner');
    this.$infoWindowElement = $('.info-window-mobile');
    // handle for iPhone (safari and firefox) only
    let canHandle = !!platform && window.navigator.platform === 'iPhone';
    canHandle = canHandle && platform.product === 'iPhone';
    canHandle = canHandle && (platform.name === 'Safari' || platform.name === 'Firefox');
    canHandle && this.$mapElement && this.$mapElement.addClass('iphone');
    canHandle && this.$infoWindowElement && this.$infoWindowElement.addClass('iphone');
    this.sendGAMapLoaded();
  }

  setActiveMarker(active: string) {
    this.infoMarker.map((marker) => {
      marker.setActiveMarker(active === marker.key);
    });
  }

  subscribeCurrency() {
    this.currency = this.currencyService.getCurrency();
    this.currencySubscription = this.currencyService.getCurrencyObs().subscribe(currency => {
      this.currency = currency;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-map-nearby/dialog-map-nearby.component.ts